<template>
  <div class="billed-container">
    <div class="export-button-container">
      <van-button
        round
        class="export-button"
        :data-bid="$BID.BILL_LIST_EXPORT"
        :data-cid="cid"
        @click="toExportBill"
      >
        导出账单
      </van-button>
    </div>
    <van-list
      v-if="newbilledList.length > 0"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了～"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getData"
    >
      <van-index-bar :sticky-offset-top="43">
        <div
          v-for="(billed, billedIndex) in newbilledList"
          :key="billedIndex"
        >
          <van-index-anchor>
            <span class="col-left">{{ billed.cutMonth | formatYearMonth }}</span>
            <span
              v-if="isAgentUser"
              class="col-right"
            >
              收入总额：{{ billed.monthTotalAmount | formatAmount }}元
            </span>
          </van-index-anchor>
          <div
            v-for="(item, itemIndex) in billed.list"
            :key="itemIndex"
            class="panel-box"
          >
            <div class="panel-head">
              <span class="head-left">
                <span class="head-title">{{ item.cutMonth | getMonth }}月</span>
                <span
                  v-if="item.subAccountId"
                  class="sub-title"
                >子账号：{{ item.subAccountId }}</span>
              </span>
              <BillStatus
                v-if="item.actualAmount >= 0"
                :status="item.billStatus"
              />
            </div>
            <div

              class="panel-content"
              @click="gotoPage(item)"
            >
              <div class="row">
                <span class="col-left"> 出账日期：{{ item.billTime }} </span>
                <span class="col-right"> 共{{ item.poiCount }}家门店 </span>
              </div>
              <div
                v-if="item.actualAmount >= 0"
                class="row"
              >
                <span class="col-left">
                  <template v-if="isAgentUser">
                    我的分成：<span
                      class="number"
                    >{{ item.totalDivideAmount | formatAmount }}元</span>
                  </template>
                </span>
                <span class="col-right">
                  实收金额：<span class="number">{{ item.actualAmount | formatAmount }}元</span>
                </span>
              </div>
              <div
                v-else
                class="no-profit"
              >
                本月无收益
              </div>
            </div>
          </div>
        </div>
      </van-index-bar>
    </van-list>
    <NoBillTips
      v-else
      msg="暂无已出账单"
    />
  </div>
</template>
<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import List from 'vant/lib/list';
import IndexBar from 'vant/lib/index-bar';
import IndexAnchor from 'vant/lib/index-anchor';
import Button from 'vant/lib/button';
import { formatYearMonth, getMonth } from '@/util/filter';
import NoBillTips from '@/components/NoBillTips';
import BillStatus from '@/components/BillStatus';
import STATUS from '@/constants/status';
import 'vant/lib/index-bar/style';
import 'vant/lib/index-anchor/style';

export default {
  name: 'BilledList',
  components: {
    [List.name]: List,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Button.name]: Button,
    NoBillTips,
    BillStatus,
  },
  filters: {
    formatYearMonth,
    getMonth,
  },
  data() {
    return {
      billedList: [], // 已出账单列表
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 10,
      cid: this.$CID.BillList,
    };
  },
  computed: {
    ...mapState('billModule', ['hasHistoryBill', 'currentBilledInfo']),
    ...mapGetters(['isAgentUser']),
    newbilledList() {
      const result = this.billedList.reduce((arr, item) => {
        if (arr.length === 0) {
          arr.push({
            cutMonth: item.cutMonth,
            monthTotalAmount: item.monthTotalAmount,
            list: [item],
          });
        } else {
          if (arr[arr.length - 1].cutMonth === item.cutMonth) {
            arr[arr.length - 1].list.push(item);
          } else {
            arr.push({
              cutMonth: item.cutMonth,
              monthTotalAmount: item.monthTotalAmount,
              list: [item],
            });
          }
        }
        return arr;
      }, []);
      return result;
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations('billModule', ['setCurrentBilledInfo']),
    ...mapActions('billModule', ['getBillList']),
    async init() {
      this.pageNum = 1;
      this.finished = false;
      this.billedList = [];
      await this.getData();
    },
    async getData() {
      const params = {
        billType: 1,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      try {
        const res = await this.getBillList(params) || {};
        if (res.code === STATUS.SUCCESS && res.data) {
          const { isFinished = true, content } = res.data;
          this.billedList = this.billedList.concat(content || []);
          this.finished = isFinished;
          if (!this.finished) {
            this.pageNum += 1;
          }
        } else {
          this.error = true;
        }
      } catch (e) {
        console.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    gotoPage(data) {
      this.$route.meta.keepAlive = true;
      this.setCurrentBilledInfo(data);
      this.$router.push({
        name: 'BilledDetail',
      });
    },
    toExportBill() {
      this.$router.push({
        name: 'ExportBillAfterTimeNode',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/page/bill.scss";
@import "@/assets/css/theme.scss";

.bill-container {
  .billed-container {
    font-size: 24px;
    /deep/ .van-index-anchor {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.28rem;
      color: #000000;
      margin: 0;
      padding: 0 54px;
    }
    /deep/ .van-index-anchor--sticky{
      color: #000000;
      background-color: #f8f8f8;
    }
    /deep/ .van-index-bar__sidebar {
      display: none;
    }
    .number {
      color: #000000;
      font-weight: bold;
    }
    .no-profit {
      padding: 10px ;
      text-align: center;
    }
  }

  .export-button-container {
    display: flex;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 0.18rem 0.18rem 0.09rem;

    .export-button {
      background: $mt_yellow;
    }
  }

  .confirm-container{
    margin: 0.18rem;
    padding: 0.18rem;
    border-radius: 12px;
    background:white;
    text-align: left;

    .btn-container {
      text-align: right;
    }

    .confirm-button {
      background:#47cb14;
      color: white;
    }
  }
}
</style>
